import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'

import Dropdown from '@components/shared/form/Dropdown'
import { useSession } from '@stores/globalData/globalData.store'
import { ThemeType } from '@utils/global'
import Storage from '@utils/storage'

const ThemeSelector: React.FC = () => {
  const { t } = useTranslation()
  const [theme, setTheme] = useState(Storage.theme)
  const session = useSession()

  /**
   * Changes the local storage theme as well as the class name in the DOM if necessary. This allows
   * the theme to be switched without having to reload the page.
   */
  const changeTheme = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const themeType = e.target.value as ThemeType
    setTheme(themeType)
    Storage.theme = themeType

    // Add/remove dark class in DOM
    if (
      themeType === ThemeType.DARK ||
      (themeType === ThemeType.SYSTEM_DEFAULT &&
        window.matchMedia('(prefers-color-scheme: dark)').matches)
    ) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }

  // TODO: Remove this once released to everyone
  if (!session.gatedFeatures.canUseDarkMode()) {
    return null
  }
  return (
    <Dropdown variant="sm" name="theme" value={theme} onChange={changeTheme}>
      <option value={ThemeType.LIGHT}>{t('userSidebar.theme.light')}</option>
      <option value={ThemeType.DARK}>{t('userSidebar.theme.dark')}</option>
      <option value={ThemeType.SYSTEM_DEFAULT}>{t('userSidebar.theme.system')}</option>
    </Dropdown>
  )
}

export default ThemeSelector
